import { render, staticRenderFns } from "./SupervisorSubmitTab.vue?vue&type=template&id=1bcd12b0&scoped=true"
import script from "./SupervisorSubmitTab.vue?vue&type=script&lang=js"
export * from "./SupervisorSubmitTab.vue?vue&type=script&lang=js"
import style0 from "./SupervisorSubmitTab.vue?vue&type=style&index=0&id=1bcd12b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd12b0",
  null
  
)

export default component.exports